var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.sectionTitle},[_c('div',{},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.subTitle))]),_c('h2',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }